export const CRASH_AUTOPLAY_CONFIG_DEFAULTS = {
    roundsOptions: [5, 10, 25, 100],
    roundsAddons: [2, 5, 10],
    maxRoundsLimit: 999,
  };